var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mt-4 mb-3"},[_c('v-col',{staticClass:"pa-0",attrs:{"sm":"12"}},[_c('v-card',{attrs:{"height":"100%","width":"100%","tile":""}},[_c('YandexMaps',{attrs:{"zoom":13,"coordinates":[this.latitude, this.longitude]}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }